<script setup lang="ts">
import { ref, watch } from "vue"
import i18n from '@/lang/i18n';
import ConfirmationModal from "@/components/Common/ConfirmationModalBase.vue";

type Props = {
  modalState: boolean,
  title?: string,
  titleClass?: string,
  subTitle?: string,
  subTitleClass?: string,
  note?: string,
  noteClass?: string,
  confirmBtnName?: string | null,
  confirmBtnClass?: string,
  cancelBtnName?: string | null,
  cancelBtnClass?: string,
  btnClass?: string,
  modalMaxWidth?: string,
  loading?: boolean,
};
const props = withDefaults(defineProps<Props>(), {
  modalState: false,
  title: i18n.global.t('common.confirmationModal.title'),
  confirmBtnName: i18n.global.t('common.confirmBtn'),
  cancelBtnName: i18n.global.t('common.cancelBtn'),
  titleClass: 'confirmation-modal-title',
  subTitleClass: 'confirmation-modal-subtitle',
  noteClass: 'confirmation-modal-note',
  cancelBtnClass: 'reset-btn',
});
const localModalState = ref(false)

watch(() => props.modalState, (value) => {
  localModalState.value = value
})

const emits = defineEmits(['confirm', 'cancel'])

function confirm() {
  emits("confirm");
}

function cancel() {
  emits("cancel");
  localModalState.value = false
}
</script>

<style>
</style>

<template>
  <ConfirmationModal
    :title="props.title"
    :note="props.note"
    :modalState="props.modalState"
    :rightBtnName="props.cancelBtnName"
    :rightBtnClass="props.cancelBtnClass"
    @rightBtnAction="cancel"
    :leftBtnName="props.confirmBtnName"
    :leftBtnClass="props.confirmBtnClass"
    @leftBtnAction="confirm"
    :leftLoading="props.loading"
  />
</template>
